if (!customElements.get('zenkon-navigation')) {
  customElements.define('zenkon-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const items = Array.from(this.querySelectorAll('.zenkon-sfx-nav__categories > .zenkon-sfx-nav__item'));
      const desktop = () => window.matchMedia('(min-width: 1025px)').matches;
      const fitPanel = item => {
        const panel = item.querySelector('.zenkon-sfx-nav__panel');
        if (!panel) return;
        panel.style.maxHeight = desktop() && item.open ? `${Math.max(120, window.innerHeight - panel.getBoundingClientRect().top - 64)}px` : '';
        panel.style.overflowY = desktop() && item.open ? 'auto' : '';
      };
      window.addEventListener('resize', () => items.forEach(fitPanel), { passive: true });
      items.forEach(item => {
        item.querySelector('summary').addEventListener('click', event => {
          if (desktop() && event.detail > 0) { event.preventDefault(); item.open = true; }
        });
        item.addEventListener('pointerenter', event => {
          if (desktop() && event.pointerType === 'mouse') item.open = true;
        });
        item.addEventListener('pointerleave', event => {
          if (desktop() && event.pointerType === 'mouse') item.open = false;
        });
        item.addEventListener('toggle', () => {
          if (item.open) items.forEach(other => { if (other !== item) other.open = false; });
          fitPanel(item);
        });
        item.addEventListener('focusout', event => {
          if (desktop() && !item.contains(event.relatedTarget)) item.open = false;
        });
      });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const item = event.target.closest('details');
        if (item) { item.open = false; item.querySelector('summary').focus(); }
      });
    }
  });
}
